import type { AudioFileSource } from '@/features/media-file/domain/models/media-file'
import { isMediaSource } from '../predicates/is-media-source'
import { isRecordingSource } from '../predicates/is-recording-source'
import { uploadFileToPath } from './upload-file-to-path'

export const getSourceId = async (source: AudioFileSource): Promise<string> => {
  if (isMediaSource(source)) return source.mediaFile.id
  if (source.mediaFile) return source.mediaFile.id
  const uploadPath = isRecordingSource(source)
    ? 'home/recordings'
    : 'home/uploads'
  return await uploadFileToPath(source.file, uploadPath, 'voice')
}
